import { render, staticRenderFns } from "./UploadFloorPlanDialog.vue?vue&type=template&id=1983a6fe&scoped=true&"
import script from "./UploadFloorPlanDialog.vue?vue&type=script&lang=ts&"
export * from "./UploadFloorPlanDialog.vue?vue&type=script&lang=ts&"
import style0 from "./UploadFloorPlanDialog.vue?vue&type=style&index=0&id=1983a6fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1983a6fe",
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QIcon,QSpinnerTail,QLinearProgress,QCardActions} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QIcon,QSpinnerTail,QLinearProgress,QCardActions})
